'use client'

import { usePathname } from 'next/navigation'
import { FileText } from 'lucide-react'
import { formatImageURL } from '@/utils/util'
import { navigateUrl } from '@/utils/client-request'
import ShopmnIcon from '@/assets/logo-icon-black.svg'

export default function About({ vendor }: { vendor?: any }) {
  const pathname = usePathname() || ''
  const vendorName = vendor?.name || 'Дэлгүүр'
  const aboutHtml: string | null = vendor?.about || null

  return (
    <section className="bg-cream pb-16">
      <div className="mx-auto max-w-[1280px] px-4 sm:px-6 lg:px-10 pt-6">
        <nav className="text-[13px] text-foreground/55 mb-6">
          <a href={navigateUrl('/', pathname)} className="hover:text-foreground">Нүүр</a>
          <span className="mx-1.5">/</span>
          <span className="text-foreground">Бидний тухай</span>
        </nav>
      </div>

      <div className="relative w-full bg-[#FFD9E7] overflow-hidden">
        <div
          role="img"
          aria-label={vendorName}
          className="absolute inset-y-0 right-0 w-1/2 bg-foreground opacity-10 pointer-events-none"
          style={{
            WebkitMaskImage: `url(${vendor?.logo ? formatImageURL(vendor.logo) : (ShopmnIcon as any).src || ShopmnIcon})`,
            maskImage: `url(${vendor?.logo ? formatImageURL(vendor.logo) : (ShopmnIcon as any).src || ShopmnIcon})`,
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
            WebkitMaskPosition: 'right center',
            maskPosition: 'right center',
            WebkitMaskSize: 'contain',
            maskSize: 'contain',
          }}
        />
        <div className="relative mx-auto max-w-[1280px] px-4 sm:px-6 lg:px-10 py-16 sm:py-24 lg:py-32 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="text-[11px] font-semibold uppercase tracking-[0.16em] text-foreground/55">Бидний тухай</div>
            <h1 className="mt-4 font-bold font-gilroy tracking-[-0.025em] leading-[0.95] text-foreground" style={{ fontSize: 'clamp(2.5rem, 7vw, 6rem)' }}>
              Сайн уу, бид бол
              <span className="block">{vendorName}.</span>
            </h1>
            {vendor?.description && (
              <p className="mt-6 text-[16px] sm:text-[18px] leading-[1.55] text-foreground/80 max-w-xl">
                {vendor.description}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1280px] px-4 sm:px-6 lg:px-10 mt-12">
        {aboutHtml ? (
          <div
            className="doc-prose text-[16px] sm:text-[17px] leading-[1.75] text-foreground/85"
            dangerouslySetInnerHTML={{ __html: aboutHtml }}
          />
        ) : (
          <div className="rounded-2xl border border-dashed border-foreground/15 bg-[#F1EEE7]/40 p-10 text-center">
            <FileText className="size-10 text-foreground/40 mx-auto mb-3" />
            <p className="text-[14px] text-foreground/55">Одоогоор бидний тухай мэдээлэл нэмэгдээгүй байна.</p>
          </div>
        )}
      </div>
    </section>
  )
}
